module.exports = {
	"household": {
		"id": 1,
		"old_category_id": 1,
		"name": "household",
		"title": "Домашние вещи",
		"sort": 1,
		"stuff": [],
		"params": [
			1,
			3,
			4,
			5,
			7,
			8,
			42,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			18,
			22,
			34,
			23,
			47,
			2,
			2,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58,
			37,
			59
		],
		"attributes": [
			23,
			2,
			3,
			4,
			5,
			6,
			1,
			7,
			8,
			9,
			10,
			11
		],
		"cargos": [
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			11,
			18,
			20,
			19
		]
	},
	"moving": {
		"id": 2,
		"old_category_id": 2,
		"name": "moving",
		"title": "Переезд",
		"sort": 2,
		"stuff": [],
		"params": [
			1,
			3,
			4,
			5,
			7,
			8,
			42,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			18,
			22,
			34,
			23,
			47,
			2,
			2,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58,
			37,
			59
		],
		"attributes": [
			8,
			11,
			1,
			23,
			2,
			3,
			4,
			5,
			6,
			7,
			9,
			10
		],
		"cargos": [
			21,
			23,
			24,
			22
		]
	},
	"vehicle": {
		"id": 3,
		"old_category_id": 7,
		"name": "vehicle",
		"title": "Автомобили",
		"sort": 3,
		"stuff": [],
		"params": [
			10,
			42,
			3,
			4,
			7,
			41,
			23,
			47,
			8,
			34,
			49,
			52,
			53,
			54,
			55,
			59
		],
		"attributes": [
			1,
			8,
			11,
			12,
			13,
			14,
			15,
			16
		],
		"cargos": []
	},
	"passing": {
		"id": 8,
		"old_category_id": 11,
		"name": "passing",
		"title": "Попутные грузы",
		"sort": 4,
		"stuff": [],
		"params": [
			1,
			3,
			4,
			5,
			7,
			8,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			23,
			24,
			25,
			27,
			28,
			29,
			30,
			31,
			32,
			33,
			34,
			38,
			42,
			43,
			44,
			45,
			46,
			47,
			48,
			48,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58,
			59
		],
		"attributes": [
			23,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			11
		],
		"cargos": [
			38,
			43,
			44,
			37,
			41,
			28,
			26,
			83,
			1,
			2,
			3,
			18,
			19
		]
	},
	"book_separate_car": {
		"id": 20,
		"old_category_id": 12,
		"name": "book_separate_car",
		"title": "Заказать отдельную машину",
		"sort": 5,
		"stuff": [],
		"params": [
			1,
			1,
			2,
			3,
			4,
			5,
			7,
			8,
			10,
			11,
			12,
			13,
			14,
			15,
			18,
			23,
			24,
			25,
			27,
			28,
			29,
			30,
			31,
			32,
			33,
			34,
			37,
			38,
			42,
			43,
			44,
			45,
			46,
			47,
			48,
			48,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58,
			59
		],
		"attributes": [
			23,
			2,
			3,
			4,
			5,
			6,
			7,
			1,
			8,
			11,
			21,
			24
		],
		"cargos": [
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			86,
			19
		]
	},
	"building": {
		"id": 7,
		"old_category_id": 3,
		"name": "building",
		"title": "Строительные грузы",
		"sort": 6,
		"stuff": [],
		"params": [
			1,
			3,
			4,
			5,
			7,
			8,
			10,
			11,
			12,
			13,
			14,
			15,
			18,
			19,
			23,
			24,
			25,
			27,
			28,
			29,
			30,
			31,
			33,
			34,
			37,
			38,
			42,
			43,
			44,
			45,
			46,
			47,
			48,
			48,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58,
			59
		],
		"attributes": [
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			11,
			21,
			23,
			24
		],
		"cargos": [
			38,
			50,
			39,
			40,
			74,
			41,
			42,
			43,
			44,
			45,
			46,
			48,
			37,
			49,
			19
		]
	},
	"commercial": {
		"id": 15,
		"old_category_id": 3,
		"name": "commercial",
		"title": "Коммерческие грузы",
		"sort": 7,
		"stuff": [],
		"params": [
			1,
			3,
			4,
			5,
			7,
			8,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			18,
			23,
			24,
			27,
			28,
			29,
			30,
			31,
			32,
			33,
			34,
			37,
			38,
			41,
			42,
			43,
			44,
			45,
			46,
			47,
			48,
			48,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58,
			59
		],
		"attributes": [
			23,
			2,
			3,
			4,
			5,
			6,
			7,
			1,
			8,
			11,
			21,
			24
		],
		"cargos": [
			52,
			57,
			53,
			58,
			54,
			38,
			55,
			40,
			56,
			50,
			43,
			44,
			37,
			41,
			51,
			28,
			11,
			19
		]
	},
	"food": {
		"id": 13,
		"old_category_id": 10,
		"name": "food",
		"title": "Продукты питания",
		"sort": 10,
		"stuff": [],
		"params": [
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			42,
			10,
			5,
			18,
			8,
			24,
			27,
			28,
			30,
			31,
			32,
			34,
			23,
			38,
			43,
			44,
			45,
			46,
			47,
			48,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58
		],
		"attributes": [
			23,
			2,
			3,
			4,
			5,
			6,
			7,
			1,
			8,
			11
		],
		"cargos": [
			63,
			64,
			65,
			66,
			67,
			68,
			69,
			70,
			62,
			19
		]
	},
	"moto": {
		"id": 4,
		"old_category_id": 7,
		"name": "moto",
		"title": "Мототехника",
		"sort": 999,
		"stuff": [],
		"params": [
			10,
			42,
			18,
			3,
			4,
			7,
			27,
			34,
			23,
			47,
			49,
			52,
			53,
			54,
			55,
			59
		],
		"attributes": [
			2,
			3,
			4,
			5,
			7,
			1,
			8,
			11,
			6,
			23
		],
		"cargos": []
	},
	"water_transport": {
		"id": 5,
		"old_category_id": 7,
		"name": "water_transport",
		"title": "Водный транспорт",
		"sort": 999,
		"stuff": [],
		"params": [
			10,
			42,
			3,
			4,
			7,
			24,
			25,
			30,
			31,
			19,
			34,
			23,
			38,
			43,
			44,
			45,
			46,
			47,
			48,
			49,
			52,
			53,
			54,
			55,
			59
		],
		"attributes": [
			2,
			3,
			4,
			5,
			7,
			1,
			8,
			11,
			20,
			22,
			23,
			6
		],
		"cargos": []
	},
	"vehicle_and_parts": {
		"id": 6,
		"old_category_id": 7,
		"name": "vehicle_and_parts",
		"title": "Транспорт и запчасти",
		"sort": 999,
		"stuff": [],
		"params": [
			3,
			4,
			7,
			8,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			18,
			19,
			23,
			24,
			25,
			27,
			28,
			30,
			31,
			34,
			38,
			41,
			42,
			43,
			44,
			45,
			46,
			47,
			48,
			48,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58,
			59
		],
		"attributes": [
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			11,
			20,
			22,
			23
		],
		"cargos": [
			26,
			27,
			28,
			29,
			30,
			31,
			32,
			33,
			34,
			35,
			25,
			36,
			19
		]
	},
	"loose": {
		"id": 9,
		"old_category_id": 12,
		"name": "loose",
		"title": "Сыпучие грузы",
		"sort": 999,
		"stuff": [],
		"params": [
			10,
			42,
			8,
			24,
			25,
			29,
			30,
			31,
			33,
			34,
			37,
			23,
			38,
			43,
			44,
			45,
			46,
			47,
			48,
			49,
			52,
			53,
			54,
			55
		],
		"attributes": [
			5,
			8,
			21,
			7,
			23,
			24,
			6
		],
		"cargos": [
			75,
			76,
			74,
			19
		]
	},
	"agricultural": {
		"id": 11,
		"old_category_id": 12,
		"name": "agricultural",
		"title": "Сельхоз. продукция",
		"sort": 999,
		"stuff": [],
		"params": [
			10,
			42,
			8,
			24,
			25,
			30,
			31,
			32,
			33,
			23,
			38,
			43,
			44,
			45,
			46,
			47,
			48,
			49,
			52,
			53,
			54,
			55
		],
		"attributes": [
			23,
			21,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			11,
			24
		],
		"cargos": [
			78,
			68,
			67,
			81,
			82,
			77,
			19
		]
	},
	"special": {
		"id": 19,
		"old_category_id": 12,
		"name": "special",
		"title": "Спец. грузы и другое",
		"sort": 999,
		"stuff": [],
		"params": [
			1,
			3,
			4,
			5,
			7,
			8,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			18,
			23,
			24,
			25,
			27,
			28,
			29,
			30,
			31,
			32,
			33,
			34,
			38,
			42,
			43,
			44,
			45,
			46,
			47,
			48,
			48,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58,
			59
		],
		"attributes": [
			23,
			2,
			3,
			4,
			5,
			6,
			7,
			1,
			9,
			10,
			8,
			11,
			21,
			24
		],
		"cargos": [
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			19
		]
	},
	"moving_cian": {
		"id": 22,
		"old_category_id": 2,
		"name": "moving_cian",
		"title": "Переезд cian.ru",
		"sort": 999,
		"hide": 1,
		"stuff": [],
		"params": [
			1,
			3,
			4,
			5,
			7,
			8,
			42,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			18,
			22,
			34,
			23,
			47,
			2,
			2,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58,
			59
		],
		"attributes": [
			8,
			11,
			1,
			23,
			2,
			3,
			4,
			5,
			6,
			7,
			9,
			10
		],
		"cargos": [
			21,
			23,
			24,
			22
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./configs/categories.config.json
// module id = 527
// module chunks = 0